<template>
  <!-- <mdb-navbar>
    <mdb-navbar-brand href="https://mdbootstrap.com/">
      <img src="../../assets/logo.png" />
    </mdb-navbar-brand>
    <mdb-navbar-toggler>
      <mdb-navbar-nav center>
        <mdb-nav-item><span style="color: #de6776;">Coronavirus (COVID-19)</span> <span style="color: #7b52d5">Map Infographics Center</span></mdb-nav-item>
      </mdb-navbar-nav>
    </mdb-navbar-toggler>
  </mdb-navbar>-->

  <b-navbar :fixed-top="true"	>
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img src="../../assets/logo.png" alt="Infodemics" />
      </b-navbar-item>
    </template>
    <template slot="start">
      <b-navbar-item>
        <b style="color: #de6776;">Coronavirus (COVID-19)</b>
      </b-navbar-item>
      <b-navbar-item>
        <b style="color: #7b52d5">Map Infographics Center</b>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
export default {
  data() {
    return {};
  },
  name: "Header"
};
</script>